import { useEffect } from 'react';

import { useRouter } from 'next/router';

import { useShortURL } from 'lib/hooks/useShortURL';

function useShortURLDubbing({ url }: { url: string }) {
  const router = useRouter();

  const { error, loading, refetch, shortURL } = useShortURL(url);

  useEffect(() => {
    refetch();
  }, [router.asPath]);

  return { shortURL, loading, error };
}

export default useShortURLDubbing;
